import { Bookmark } from '@ipfabric/ui-components/Bookmark/Bookmark';
import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { prop } from '@ipfabric/utils/fp/prop';
import { type ReactNode, useMemo } from 'react';
import { useGlobalStateContextSelectors } from '../GlobalState/GlobalStateModel';
import { togglePinnedPage } from '../GlobalState/commands/togglePinnedPage';

type Props = {
  className?: string;
  urlPath: string;
};

export const PageBookmark = (props: Props): ReactNode => {
  const ctxGlobalProps = useGlobalStateContextSelectors({
    pinnedPages: prop('user', 'pinnedPages'),
    dispatch: prop('dispatch'),
  });

  const [bookmarkLoading, setBookmarkLoading] = useLoadingState();

  const isPinned = useMemo(
    () => ctxGlobalProps.pinnedPages.includes(props.urlPath),
    [ctxGlobalProps.pinnedPages, props.urlPath],
  );

  const handleClick = () =>
    withLoadingIndicator(setBookmarkLoading)(() =>
      ctxGlobalProps.dispatch(togglePinnedPage, {
        urlPath: props.urlPath,
      }),
    );

  return (
    <Bookmark
      className={props.className}
      loading={bookmarkLoading === 'LOADING'}
      selected={isPinned}
      onClick={handleClick}
    />
  );
};
